const openBankingConnectionStatusConstants = Object.freeze({
  PENDING: 'pending',
  SYNCING: 'syncing',
  ACTIVE: 'active',
  EXPIRING_SOON: 'expiring_soon',
  EXPIRED: 'expired',
  REVOKED: 'revoked',
  DISCONNECTED: 'disconnected',
  ERROR: 'error',
});

export { openBankingConnectionStatusConstants };
